import { useEffect } from 'react'

/**
 * Warns the user when they try to close the tab or navigate away with unsaved changes.
 * Uses beforeunload for browser-level navigation (tab close, URL change, refresh).
 * @param {boolean} isDirty - Whether the form has unsaved changes
 */
export default function useUnsavedChanges(isDirty) {
  useEffect(() => {
    if (!isDirty) return

    const handler = (e) => {
      e.preventDefault()
      e.returnValue = ''
    }

    window.addEventListener('beforeunload', handler)
    return () => window.removeEventListener('beforeunload', handler)
  }, [isDirty])
}
